import React from 'react';
import { useNavigate } from 'react-router-dom';

function Dashboard() {
  const navigate = useNavigate();

  return (
    <div className="content-main">
      <div className="dashboard-header">
        <h1 className="dashboard-title">Welcome back</h1>
        <p className="dashboard-subtitle">Manage your App Store Connect apps and developer resources</p>
      </div>
      
      <div className="dashboard-cards">
        <div 
          className="dashboard-card"
          onClick={() => navigate('/appstore')}
        >
          <div className="dashboard-card-icon">📱</div>
          <h2 className="dashboard-card-title">App Store</h2>
          <p className="dashboard-card-description">
            Manage your app submissions, metadata, screenshots, and prepare for App Store review
          </p>
          <ul className="dashboard-card-features">
            <li>App Information & Localization</li>
            <li>Version Management</li>
            <li>Screenshots & Previews</li>
            <li>Build Selection</li>
            <li>Age Rating & Privacy</li>
            <li>Submit for Review</li>
          </ul>
        </div>

        <div 
          className="dashboard-card"
          onClick={() => navigate('/developer')}
        >
          <div className="dashboard-card-icon">⚙️</div>
          <h2 className="dashboard-card-title">Developer</h2>
          <p className="dashboard-card-description">
            Manage development resources, certificates, and provisioning profiles
          </p>
          <ul className="dashboard-card-features">
            <li>Device Management</li>
            <li>Certificates</li>
            <li>Provisioning Profiles</li>
            <li>Bundle IDs</li>
          </ul>
        </div>
      </div>

      <div className="quick-tip">
        <span className="quick-tip-icon">💡</span>
        <div className="quick-tip-content">
          <h4>Quick Start</h4>
          <p>
            Select <strong>App Store</strong> to manage your app submissions and metadata, 
            or <strong>Developer</strong> to manage certificates, devices, and profiles.
          </p>
        </div>
      </div>
    </div>
  );
}

export default Dashboard;
